module.exports = __webpack_public_path__ + "img/close.e1610f9d.svg";